import * as actionTypes from "./ActionTypes"
import { APIGet, APIPost } from "services/APIRequest"
import UrlServer from "configs/UrlServer"

export const updateAnswers = (datas) => {
  return { type: actionTypes.UPDATE_ANSWERS, answers: datas }
  // return dispatch => {
  //   APIGet(UrlServer.URL_POST_COUNTRY_ADMIN, datas => {
  //     dispatch({ type: actionTypes.UPDATE_ANSWERS, answers: datas.datas })
  //   })
  // }
}
